import React from 'react'
import { Loader } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const LoadingPage = () => {
  // Opt out of Suspense just for this component
  const { t, i18n, ready } = useTranslation('common', { useSuspense: false })
  const isReady = Boolean(i18n?.isInitialized && ready)

  return (
    <div>
      <Loader size="big" active>
        {isReady ? t('Loading') : 'Loading…'}
      </Loader>
    </div>
  )
}

export default LoadingPage
